import { watch } from 'vue'

export default function useWorkingHoursHook(state, emit) {
  for (let i = 0; i < state.days.length; i++) {
    let dayObj = state.days[i]
    const dayKey = dayObj.day.toLowerCase().substr(0, 3)
    if (state.modelValue[dayKey] && state.modelValue[dayKey].length) {
      dayObj.active = true
      dayObj.from = state.modelValue[dayKey][0].start
      dayObj.to = state.modelValue[dayKey][0].end
      state.days[i] = dayObj
    } else {
      state.modelValue[dayKey] = []
    }
  }

  watch(state.days, (value) => {
    value.forEach((dayObj) => {
      const dayKey = dayObj.day.toLowerCase().substr(0, 3)
      if (dayObj.active && dayObj.from.length === 5 && dayObj.to.length === 5) {
        state.modelValue[dayKey] = [
          {
            start: dayObj.from,
            end: dayObj.to,
          },
        ]
      } else {
        state.modelValue[dayKey] = []
      }
    })
    emit('update:modelValue', state.modelValue)
  })

  /**
   * @param {{active: boolean, from: string, to: string, day: string, invalid: boolean}} item
   * @param {number} index
   */
  const handleValidateTime = (item, index) => {
    item.from = item.from.length === 5 ? validateTime(item.from) : item.from
    item.to = item.to.length === 5 ? validateTime(item.to) : item.to
    item.invalid = checkInput(item, index)
  }

  /**
   * @param {{active: boolean, from: string, to: string, day: string, invalid: boolean}} item
   * @param {number} index
   */
  const checkInput = (item) => {
    if (item.active) {
      if (item.from === '' || item.to === '') {
        state.error = 'Please enter the working hours for the selected day(s).'
        return true
      }
      if (item.from === item.to) {
        state.error = 'The start time and the end time cannot be the same.'
        return true
      }
      let from = item.from.split(':').join('')
      let to = item.to.split(':').join('')
      if (Number(from) >= Number(to)) {
        state.error = 'The start time should not be after the end time.'
        return true
      }
    }
    state.error = ''
    return false
  }

  const validateTime = (input) => {
    if (input !== '') {
      const timeRegex = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/
      const isValid = timeRegex.test(input)
      return isValid ? input : ''
    }
    return input
  }

  return { state, handleValidateTime }
}
